<template>
    <v-container>
        <v-layout row wrap>
            <v-flex xs12 sm6 md6>
                <v-card flat class="text-xs-center ma-3" width="100%">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Liberación Jurídica</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon :color="'#FFFFFF'">mdi-car-info</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-list-item>
                            <v-list-item-action class="mr-1">SI</v-list-item-action>
                            <v-list-item-action>NO</v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div v-for="(movimiento) in this.movlvlj" :key="movimiento.orden">
                            <v-list-item>
                                <v-list-item-action class="mr-1">
                                    <v-checkbox :on-icon="'mdi-check-circle-outline'"
                                        :off-icon="'mdi-checkbox-blank-circle-outline'" class="disable-action"
                                        v-model="movimiento.respuestaSI"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-action>
                                    <v-checkbox :on-icon="'mdi-check-circle-outline'"
                                        :off-icon="'mdi-checkbox-blank-circle-outline'" class="disable-action"
                                        v-model="movimiento.respuestaNO"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content class="ml-1" style="color:black">
                                    {{ movimiento.nombre }}
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6>
                <v-card flat class="text-xs-center ma-3" width="100%" v-if="this.mostrar">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Liberación Física</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon :color="'#FFFFFF'">mdi-car-info</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-list-item>
                            <v-list-item-action class="mr-1">SI</v-list-item-action>
                            <v-list-item-action>NO</v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div v-for="(movimiento) in this.movlvlf" :key="movimiento.orden">
                            <v-list-item>
                                <v-list-item-action class="mr-1">
                                    <v-checkbox :on-icon="'mdi-check-circle-outline'"
                                        :off-icon="'mdi-checkbox-blank-circle-outline'" class="disable-action"
                                        v-model="movimiento.respuestaSI"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-action>
                                    <v-checkbox :on-icon="'mdi-check-circle-outline'"
                                        :off-icon="'mdi-checkbox-blank-circle-outline'" class="disable-action"
                                        v-model="movimiento.respuestaNO"></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content class="ml-1" style="color:black">
                                    {{ movimiento.nombre }}
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider></v-divider>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import LibVeh from '@/services/LibVeh/libVeh.service.js';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

export default {
    data: function () {
        return {
            mostrar: false,
            listCheck: [],
            movlvlj: [],
            movlvlf: [],
            info: []
        }
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },
    methods: {
        async AvePrevMovimientosLibVehLJ() {
            let respuestas = await LibVeh.AvePrevMovimientos(this, this.info.procesolibVeh)
            for (let i in respuestas) {
                for (const [key, value] of Object.entries(respuestas[i])) {
                    if (typeof value == "object") {
                        respuestas[i][key] = ""
                    } else {
                        if (key == "etiqueta2") {
                            respuestas[i][key] = '$' + parseInt(value).toFixed(2)
                        } else if (key == "respuestaSI" || key == "respuestaNO") {
                            respuestas[i][key] = respuestas[i][key].toLowerCase() === 'true';
                        } else {
                            respuestas[i][key] = value.toString()
                        }
                    }
                }
            }
            this.movlvlj = respuestas.filter((mov) => {
                return mov.visible === "true"
            })
            this.movlvlj = this.movlvlj.filter((mov) => mov.apartado === 'Liberación Jurídica');
            if (this.info.apodLeg == true) {
                this.movlvlf = respuestas.filter((mov) => mov.apartado === 'Liberación Física');
                this.movlvlf = this.movlvlf.filter((mov) => {
                    return mov.visible === "true"
                })
                this.mostrar = true;
            } else {
                this.mostrar = false;
            }
        },
    },
    async mounted() {
        this.info = await MetodosGenerales.obtenerSessionReporte('info');
        this.AvePrevMovimientosLibVehLJ();
    }
}

</script>